import gsap, { Power2, Power4 } from 'gsap';
import BezierEasing from 'bezier-easing';
import { isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import { CSS } from '../_app/cuchillo/utils/CSS';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import VisorVideos from '../layout/VisorVideos';
import Header from '../layout/Header';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';
import { Howl } from 'howler';


//──────────────────────────────────────────────────────────────────────────────
// Archive
//──────────────────────────────────────────────────────────────────────────────
export default class Archive extends Default {
  visor;
  scroller;
  holder;

  constructor() {
    super();

    this.holder = GetBy.class('__holder', this.container)[0];
    this.visor  = new Archive__Visor(GetBy.selector('[data-visor]')[0]);
    this.holder.style.opacity = 0;

    this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_Y, {
      domResize:       this.container,
      appendContainer: this.holder,
      container:       this.holder,
      multiplicator:   1,
      minSpeed:        0,
      inverted:        false,
      gap:             0,
      itemClass:       Archive__Visor__InfiniteItem,
      hasVirtuaScroll: true,
    });

    this.scroller._items.forEach((item, i) => {
      item.callbackShow = () => this.visor.change(i, item.data);
    });
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.directShow();
      Preloader.hide(() => { this.afterShow() });
    } else {
      Wrap.directShow();
      this.afterShow();
    }
  }

  beforeShow() {
    Header.closeHeader();
    Header.showLogo();
    this.visor.change(0, this.scroller._items[0]);
    this.visor.enabled = false;
    this.scroller.start();
    this.scroller.show();
    this.scroller.goto(Metrics.HEIGHT* -0.5, true);
    setTimeout(()=> {this.scroller.goto(Metrics.HEIGHT * -0.5)}, 100);
    setTimeout(()=> {this.visor.enabled = true;}, 1000);
    
    Keyboard.mountPage(this.id);
  }

  afterShow() {
    gsap.to(this.holder, {opacity:1, duration:.4, delay:.1, ease:Power2.easeIn});
    this._isActive = true;
  }

  beforeHide() {
    Header.hideLogo();
    this.scroller.hide();
    this.visor.hide();
    super.beforeHide();
  }

  afterHide() {
    super.afterHide();
  }

  resize() {
    super.resize();
    this.scroller.resize();
  }

  loop() {
    this.scroller.loop();
  }

  dispose() {
    super.dispose();
    this.scroller.dispose();
    this.visor.dispose();
  }
}


//──────────────────────────────────────────────────────────────────────────────
// Archive__Visor
//──────────────────────────────────────────────────────────────────────────────
class Archive__Visor {
  actual = null;
  visor;
  enabled = true;
  first = true;
  sound = new Howl({
    src: ['/assets/audio/tac.m4a'],
    volume: .4,
    preload: true,
    html5: false,
    onloaderror: (id, err) => {
      console.error("❌ Error al cargar el sonido", err);
    },
    onend: () => {}
  });

  constructor(__dom) {
    this.visor = new VisorVideos(GetBy.class('__visor_videos')[0]);
  }

  change(next, data) {
    if(!this.enabled) return;
    if (this.actual === next) return;
    if(!this.first) this.sound.play();
    this.actual = next;
    this.visor.change(next);
    this.first = false;
  }

  hide() {}

  dispose() {
    this.enabled = false;

    if (this.visor) {
      this.visor.dispose();
      this.visor = null;
    }

    if (this.sound) {
      this.sound.stop();
      this.sound.unload(); // libera el buffer de Howler
      this.sound = null;
    }

    this.actual = null;
  }
}

class Archive__Visor__InfiniteItem extends InfiniteScroll__Item {
    _card;
    _limits;
    _card;
    _figure;
    _figureOffset = 0;
    _video;
    _src;
    _isPlay;
    _isShow;
    hasMove = false;

    _tickResetLimit = Maths.maxminRandom(500, 200);
    indice = 0;
    
    sizeGap = 0;

    static easing = BezierEasing(.01, .65, 0, .95);

    
    positionShow = {
        roman: 0,
        currentRoman: 0,
        client: 0,
        currentClient: 0,
    };

    sizes =  {
      height: 0,
      width: 0
    }


    roman;
    title;
    client;
    director;
    
    constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
        super(__d, __i, __axis, true);

        this.indice = this.index;
        
        this.romanHolder = GetBy.class("counter-roman", this.dom)[0];
        this.clientHolder = GetBy.class("client", this.dom)[0];

        this.roman = GetBy.class("__roman", this.dom)[0];
        this.client = GetBy.class("__client", this.dom)[0];

       

        this.title = GetBy.class("title", this.dom)[0];
        this.director = GetBy.class("director", this.dom)[0];
        this._card = GetBy.selector('[data-project-button]', this.dom)[0];
        this._card.setAttribute("data-index", this.indice);
        
    }

    resize() {
      super.resize();

      if(this._card) {
        const rect = this._card.getBoundingClientRect();
        this.sizes.width = rect.width;
        this.sizes.height = rect.height;
        this.sizeGap = this.sizes.height * 5;

       
        this.positionShow.roman = this.roman.offsetWidth - this.romanHolder.offsetWidth;
        this.positionShow.client = Math.max(this.clientHolder.offsetWidth * .3, this.clientHolder.offsetWidth - this.client.offsetWidth);
      }
    }

    drawHook() {
        if (!this._card) return;
        this.move();
    }

    play() {
        if (this._isPlay) return;

        this._card.classList.add("--active");
        this._isPlay = true;
        this.callbackShow();
        gsap.killTweensOf(this.roman);
        gsap.killTweensOf(this.client);
        gsap.set(this.roman, {x:this.positionShow.roman * .9});
        gsap.set(this.client, {x:this.positionShow.client * .9});
        gsap.to(this.roman, {x:this.positionShow.roman, duration:.5, ease: Power4.easeOut});
        gsap.to(this.client, {x:this.positionShow.client, duration:.5, ease: Power4.easeOut});
        this.client.style.whiteSpace = "normal";
    }

    pause() {
        if (!this._isPlay) return;

        this._card.classList.remove("--active");
        this._isPlay = false;
        gsap.killTweensOf(this.roman);
        gsap.killTweensOf(this.client);
        gsap.to(this.roman, {x:0, duration:.5, ease: Power4.easeOut});
        gsap.to(this.client, {x:0, duration:.5, ease: Power4.easeOut});
        this.client.style.whiteSpace = "nowrap";
    }

    move() {       
        if(this.progressItem >= 0 && this.progressItem < 1) {
          this.play();
          this.title.style.opacity = 1;
          this.director.style.opacity = 1;
        } else {
          this.pause();
          this.title.style.opacity = 0;
          this.director.style.opacity = 0;
        }

        let yoffset = 0;
        let y = Maths.lerp(this.sizes.height, 0, this.progress);
        let yShow = 0;

        if(this.progress < 0) {
          yoffset = this.sizeGap;
          y = y + yoffset;

          this._card.style.opacity = Maths.lerp(0, 1, Maths.normalize(-2, -6, this.progress));

          this.positionShow.currentClient = 0;
          this.positionShow.currentRoman = 0;
        } else if(this.progress > 1) {
          yoffset = -this.sizeGap;
          y = y + yoffset;

          this._card.style.opacity = Maths.lerp(0, 1, Maths.normalize(3, 7, this.progress));
          y = Maths.lerp(this.sizes.height, 0, this.progress) + yoffset

          this.positionShow.currentClient = 0;
          this.positionShow.currentRoman = 0;

        } else {
          y = Maths.lerp(this.sizes.height + this.sizeGap, 0, this.progress) - this.sizeGap * .5;
          yShow = y * -.9

          
         // const pogressNorm = this.progress <= .5? Math.min(1, Maths.normalize(.5, -.5, this.progress)) : Math.max(0, Math.min(1, Maths.normalize(.9, 1, this.progress)));
          
        
       //   this.positionShow.currentClient = Maths.lerp(0, this.positionShow.client, pogressNorm);
       //   this.positionShow.currentRoman = Maths.lerp(0, this.positionShow.roman, pogressNorm);
        }
              
        this._card.style[CSS.transform] = CSS.translate3D(0, y, 0);
        this.title.style[CSS.transform] = CSS.translate3D(0, yShow, 0);
        this.director.style[CSS.transform] = CSS.translate3D(0, yShow, 0);

       // this.roman.style[CSS.transform] = CSS.translate3D(this.positionShow.currentRoman, 0, 0);
       // this.client.style[CSS.transform] = CSS.translate3D(this.positionShow.currentClient, 0, 0);
        
    }

    dispose() {
        super.dispose();
    }
}

ControllerPage._addPage("page-archive", Archive)
